module.exports = __webpack_public_path__ + "static/img/ok_two.87eb4b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ok_two.png
// module id = 3ksk
// module chunks = 1